export const COLORS = {
	main: '#ff813c',
	border: '#eaeaea',
	background: '#f5f2ea',
	accentBackground: '#e4dfd0',
	fontColor: '#545454',
	divider: '#a8a8a8',
}
